import React from 'react';
import { connect } from 'react-redux';
import mobileConfigActions from '../../../../../actions/mobileConfig.actions';
import helper from '../../../../../utils/helper';
import MobileConfigurationForm from '../CreateEditForm';

function NewMobileConfiguration(props) {
  const form = {
    name: '',
    alertsOnly: false,
    scrollTopMin: 0,
    dimDisplayMin: 0,
    keepAwake: true,
    accessibleTypes: false,
  };
  const { deptId } = helper.parseQueryString(props.location.search);
  const [isSubmitting, setSubmitting] = React.useState(false);
  const [error, setError] = React.useState('');
  const onCreate = async (values) => {
    setError('');
    setSubmitting(true);
    await props
      .createMobileConfig({
        ...values,
        departmentId: deptId,
        accessibleTypes: values.accessibleTypes ? 0 : 1,
      })
      .then(() => props.history.goBack())
      .catch((err) => {
        setSubmitting(false);
        setError(err);
      });
  };
  return (
    <MobileConfigurationForm
      initialValues={form}
      onSubmit={onCreate}
      submitting={isSubmitting}
      errors={error}
    />
  );
}

function mapStateToProps(state) {
  return {
    mobileConfig: state.mobileConfig,
  };
}

export default connect(
  mapStateToProps,
  mobileConfigActions,
)(NewMobileConfiguration);
